import { Api } from "api";

export const getDepartments = async () => {
  const hash = localStorage.getItem("hash");
  const res = await Api.get(`/departments/?hash_pw=${hash}`);
  return res.data;
};

export const addDepartment = async (department: string) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.post(`/department/?hash_pw=${hash}&department=${department}`);
  return res.data;
};

export const updateDepartment = async (departmentId: number, new_name: string, new_status: boolean) => {
  const hash = localStorage.getItem("hash");
  const name = new_name !== undefined ? `&new_department=${new_name}` : "";
  const status = new_status !== undefined ? `&status=${new_status}` : "";
  const url = `/department/?hash_pw=${hash}&department_id=${departmentId}${name}${status}`;
  const res = await Api.put(url);
  return res.data;
};
